import React from 'react';
import { Navbar, Container } from 'react-bootstrap';

const Header = () => (
  <Navbar bg="light" expand="lg" className="shadow-sm mb-3">
    <Container fluid>
      <Navbar.Brand>Admin Dashboard</Navbar.Brand>
    </Container>
  </Navbar>
);

export default Header;
